import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useLocation } from "react-router";
export const VirtualizedAppContext = React.createContext({
    name: "",
});
export const getVirtualizedAppNameInternal = (url) => {
    if (!(WATERMARK_UTILS === null || WATERMARK_UTILS === void 0 ? void 0 : WATERMARK_UTILS.getAppFromPathname)) {
        throw new Error("Cannot get app from pathname - utilities not initialized");
    }
    return WATERMARK_UTILS.getAppFromPathname(url);
};
export const getVirtualizedAppName = () => {
    return getVirtualizedAppNameInternal(window.location.pathname);
};
export const VirtualizedAppContextProvider = ({ children, }) => {
    const location = useLocation();
    const name = getVirtualizedAppNameInternal(location.pathname);
    return (
    // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
    _jsx(VirtualizedAppContext.Provider, { value: { name }, children: children }));
};
export const useVirtualizedApp = () => {
    return React.useContext(VirtualizedAppContext);
};
export default useVirtualizedApp;
